/**
 * GraphQL wraps resolver failures as `Exception while fetching data (/path) : <message>`.
 * Strip that prefix so toasts and other UI can show the underlying error.
 */
const GRAPHQL_FETCH_PREFIX = /^Exception while fetching data \([^)]+\)\s*:\s*/gm;

export function toUserFacingGraphQLError(error: unknown): unknown {
  if (!(error instanceof Error)) {
    return error;
  }
  const message = error.message.replace(GRAPHQL_FETCH_PREFIX, '').trim();
  if (!message || message === error.message) {
    return error;
  }
  return new Error(message);
}
